export class InvoiceLayoutDetails {
  public id: number;
  public content: string;
}
